import * as React from 'react';

import type { QuantityUnitType, PlainUnitEnum } from '@acceligentllc/shared/enums/quantityUnit';

interface OwnProps {
	trackedUnit: Nullable<QuantityUnitType>;
	materialUnit: Nullable<PlainUnitEnum>;
}

type Props = OwnProps;

const TooltipContent: React.FC<Props> = (props) => {
	const { trackedUnit, materialUnit } = props;

	if (!trackedUnit || !materialUnit) {
		return null;
	}

	return (
		<div>
			<div>Quantity tracked in {trackedUnit}</div>
			<div>Material declared in {materialUnit}</div>
		</div>
	);
};

export default React.memo(TooltipContent);
